export const PERMISSIONS = {
  PUBLIC: 'PUBLIC',
  CAMPAIGN: 'CAMPAIGN',
  PRIVATE: 'PRIVATE',
  USER_SPECIFIC: 'USER_SPECIFIC'
}

export const VIEW_MODE = {
  EDIT: 'edit',
  PREVIEW: 'preview',
  PUBLIC: 'public' // Read-only shared view (no editing allowed)
}

export const LINK_KINDS = {
  NOTE: 'note',
  ENTITY: 'entity',
  URL: 'url'
}

export const GRAPH_NODE_GROUPS = {
  NOTE: 'note',
  ENTITY: 'entity',
  GHOST: 'ghost'
}

export const DEFAULT_CACHE_MINUTES = 5

// Re-export vault types
export * from './vault'
